module.exports = __webpack_public_path__ + "img/cutout_duotone.21930a5.svg";